<mat-card class="w-full">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Roles Administration
      </span>
    </div>
  </mat-card-header>

  <mat-card-content class="flex justify-center items-center w-full">

    <div class="flex flex-col w-full items-center">
      <div *ngIf="!showRole" class="flex flex-col w-11/12">
        <div class="flex flex-row w-full">
          <div>
            <h2>Roles</h2>
          </div>
        </div>
        <div>
          <button mat-raised-button (click)="createRole()" class="m-8">
            <mat-icon>add</mat-icon>
            Create New Role
          </button>
        </div>
        <hr class="w-full" style="border: 1px solid gray;">

        <div class="flex flex-row w-full">

          <div class="flex flex-row w-full">

            <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort" class="w-full">

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let role">{{role.name}}
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let role">
                  <div class="flex flex-row w-full">
                    <div style="padding-right: 10px;">
                      <button mat-raised-button (click)="editRole(role)" class="m-8">
                        <mat-icon>settings</mat-icon>
                      </button>
                    </div>
                    <div>
                      <button mat-raised-button (click)="deleteRole(role)" class="m-8">
                        <mat-icon style="color: red;">delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

            </table>
          </div>

        </div>
        <!-- <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator"
          showFirstLastButtons></mat-paginator> -->
      </div>

      <div *ngIf="showRole" class="flex flex-col w-11/12">
        <div class="flex flex-col w-full">
          <div>
            <h2>Roles</h2>
          </div>
        </div>
        <div class="flex flex-row">
          <span style="padding: 20px;">Role Name:</span>
          <input [(ngModel)]="editingRole" placeholder="Role Name" class="m-8"/>
        </div>
        <div class="flex flex-row">
          <div>
            <button mat-raised-button (click)="saveRole()" class="m-8" style="background-color:#5775a8;padding: 20px;">
              Save
            </button>
          </div>
          <div>
            <button mat-raised-button (click)="cancel()" class="m-8">
              Return
            </button>
          </div>    
        </div>

      </div>
    </div>

  </mat-card-content>
</mat-card>